import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { UploadAttachment } from 'src/app/shared/components/upload-attachments/upload-attachment.model';
import { UploadAttachmentsComponent } from 'src/app/shared/components/upload-attachments/upload-attachments.component';

@Component({
    selector: 'comment-with-attachments-dialog',
    styleUrls: ['./comment-with-attachments-dialog.component.scss'],
    templateUrl: './comment-with-attachments-dialog.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogModule, UploadAttachmentsComponent, FormsModule, MatLegacyButtonModule]
})
export class CommentWithAttachmentsDialogComponent {
    comment = signal<string>('');
    attachments = signal<UploadAttachment[]>([]);
    data = signal<{
        title: string;
        infoText: string;
        dataQaId: string;
    }>({ title: '', infoText: '', dataQaId: '' });

    constructor(
        private readonly dialogRef: MatDialogRef<CommentWithAttachmentsDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        data: {
            title: string;
            infoText: string;
            dataQaId: string;
        }
    ) {
        this.data.set(data);
    }

    close(comment?: string): void {
        if (comment) {
            this.dialogRef.close({
                comments: comment,
                attachments: this.attachments()
            });
        } else {
            this.dialogRef.close(false);
        }
    }

    onSelectedFiles(files: UploadAttachment[]): void {
        this.attachments.set([...this.attachments(), ...files.map((x) => ({ ...x, pending: false }))]);
    }

    onRemovedFile(file: UploadAttachment): void {
        const items = [...this.attachments()];
        items.splice(
            items.findIndex((x) => x.title === file.title),
            1
        );
        this.attachments.set(items);
    }
}
